<template>
    <div class="top-banner ">
        <h2 class="page-title">{{ currentRouteTitle }}</h2>
        <breadcrumb-component></breadcrumb-component>
        <div class="badge"><i></i></div>
    </div>
</template>

<script>
    import BreadcrumbComponent from "./BreadcrumbComponent";
    export default {
        name: "InnerPageBannerComponent",
        components: {BreadcrumbComponent},
        computed: {
            currentRouteTitle() {
                return this.$route.meta.title;
            }
        }
    }
</script>

<style scoped lang="scss">
    .top-banner {
        height: 200px;
        padding: 0 20px;
        box-sizing: border-box;
        margin: 0;
        background: linear-gradient(70deg, #061a2b, #0e324d);
        position: relative;
        overflow: hidden;

        .badge {
            position: absolute;
            right: -10px;
            bottom: -180px;
            height: 120%;
            width: 100px;
            background: #1e6aa3;
            opacity: .7;
            transform: rotate(45deg);
            box-shadow: black 1px -1px 16px 1px;
        }


        h2.page-title {
            color: white;
            font-weight: bolder;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
        }
    }
</style>